/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An Active integration that hasn't synced recently
 * @export
 * @interface WebApiAdminDtoStaleIntegrationDto
 */
export interface WebApiAdminDtoStaleIntegrationDto {
    /**
     * Company ID
     * @type {number}
     * @memberof WebApiAdminDtoStaleIntegrationDto
     */
    companyId?: number;
    /**
     * Company name
     * @type {string}
     * @memberof WebApiAdminDtoStaleIntegrationDto
     */
    companyName?: string | null;
    /**
     * "Fortnox" or "Spiris"
     * @type {string}
     * @memberof WebApiAdminDtoStaleIntegrationDto
     */
    integrationName?: string | null;
    /**
     * The integration's current state
     * @type {string}
     * @memberof WebApiAdminDtoStaleIntegrationDto
     */
    state?: string | null;
    /**
     * When the integration last ran, if ever
     * @type {Date}
     * @memberof WebApiAdminDtoStaleIntegrationDto
     */
    lastRun?: Date | null;
    /**
     * Hours since the last run, or -1 if it has never run
     * @type {number}
     * @memberof WebApiAdminDtoStaleIntegrationDto
     */
    hoursSinceLastRun?: number;
    /**
     * The last run's response/error text, truncated
     * @type {string}
     * @memberof WebApiAdminDtoStaleIntegrationDto
     */
    lastRunResponse?: string | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoStaleIntegrationDto interface.
 */
export function instanceOfWebApiAdminDtoStaleIntegrationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoStaleIntegrationDtoFromJSON(json: any): WebApiAdminDtoStaleIntegrationDto {
    return WebApiAdminDtoStaleIntegrationDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoStaleIntegrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoStaleIntegrationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'integrationName': !exists(json, 'integrationName') ? undefined : json['integrationName'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'lastRun': !exists(json, 'lastRun') ? undefined : (json['lastRun'] === null ? null : new Date(json['lastRun'])),
        'hoursSinceLastRun': !exists(json, 'hoursSinceLastRun') ? undefined : json['hoursSinceLastRun'],
        'lastRunResponse': !exists(json, 'lastRunResponse') ? undefined : json['lastRunResponse'],
    };
}

export function WebApiAdminDtoStaleIntegrationDtoToJSON(value?: WebApiAdminDtoStaleIntegrationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'companyName': value.companyName,
        'integrationName': value.integrationName,
        'state': value.state,
        'lastRun': value.lastRun === undefined ? undefined : (value.lastRun === null ? null : value.lastRun.toISOString()),
        'hoursSinceLastRun': value.hoursSinceLastRun,
        'lastRunResponse': value.lastRunResponse,
    };
}

